const routes = [
    {
        path: '/parceiro',
        alias: [
            '/contabilidade'
        ],
        component: () => import('../views/Inicio'),
    },
    {
        path: '/parceiro/inicio',
        alias: [
            '/contabilidade/inicio'
        ],
        component: () => import('../views/Inicio'),
    },
    {
        path: '/parceiro/sistema/inicio',
        alias: [
            '/contabilidade/sistema/inicio'
        ],
        component: () => import('../views/Inicio')
    },
    {
        path: '/parceiro/empresas/inicio',
        alias: [
            '/contabilidade/empresas/inicio'
        ],
        component: () => import('../views/Inicio')
    }
]

export default routes
